<template>
    <VDropdown :class="['tooltip', `tooltip--${ position }`]">
        <font-awesome-icon :icon="[iconSet, icon]" />

        <template #popper>
            <div class="tooltip__content">
                <slot />
            </div>
        </template>
    </VDropdown>
</template>

<script>
export default {
    name: 'tooltip',

    props: {
        position: {
            type: String,
            default: 'right',
        },

        icon: {
            type: String,
            default: 'question-circle',
        },

        iconSet: {
            type: String,
            default: 'fas',
        },
    },

    mounted() {
        const relativePositions = ['top', 'bottom'];

        if (!relativePositions.includes(this.position)) return;

        const parent = this.$el.parentNode;
        const parentDisplay = window.getComputedStyle(parent).getPropertyValue('position');

        // both the "top" and "bottom" positions require the parent element to be relatively positioned
        if (parentDisplay === 'static') {
            parent.style.position = 'relative';
        }
    },
};
</script>

<style lang="scss">
.tooltip {
    font-size: 0.6875rem;
    color: var(--form-labelColor);

    &--left { margin-right: 1em; }
    &--right { margin-left: 1em; }

    &--top {
        position: absolute;
        bottom: 100%;
        left: 50%;
        transform: translateX(-50%);
        padding-bottom: 0.25em;
    }

    &--bottom {
        position: absolute;
        top: 100%;
        left: 50%;
        transform: translateX(-50%);
        padding-top: 0.5em;
    }

    &:hover {
        cursor: pointer;
    }

    &__content {
        font-size: 0.875rem;

        a,
        a:visited {
            color: $tooltip-link-color;
        }

        a:hover {
            text-decoration: underline;
            color: $tooltip-link-hover-color;
        }
    }
}
</style>
